import './App.css';
import { useEffect, useState } from 'react';
import Card from './Components/Card';
import axios from 'axios';
import NavigationBar from './Components/NavigationBar';
import { Routes, Route } from "react-router-dom";
import GloryBeigeimg from './BEIGE_GLORY_FRONT.jpg';
import HeroSection from './Components/HeroSection';
import ContactForm from './Components/ContactForm';
import Login from './Components/Login';
import Signup from './Components/Signup';
import Cart from './Components/Cart';
import Checkout from './Components/Checkout';
import AdminProtection from './Components/AdminProtection';
import AdminPanel from './Components/AdminPanel';
import CollectionCard from './Components/CollectionCard';
import CollectionPage from './Components/CollectionPage';
import UserProvider from './Components/OrderPlacement/OrderProvider';
import PlacedOrder from './Components/PlacedOrder';
import Reviews from './Components/Reviews';
import VerifyEmailOTP from './Components/VerifyEmailOTP';
import ForgotPasswordEmail from './Components/ForgotPasswordEmail';
import ResetPasswordOTP from './Components/ResetPasswordOTP';
import TrackOrder from './Components/TrackOrder';
import Footer from './Components/footer';
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [products, setProducts] = useState([]);
  const [collections, setCollections] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  console.log("API URL:", apiUrl);
  useEffect(() => {

    const userEmail = localStorage.getItem("userEmail");

    if (userEmail) {

      axios.post(`${process.env.REACT_APP_URL}/api/getProduct`, {
        email: userEmail
      })
        .then(res => {

          const { data, collections, UserUsedCodesArray } = res.data;

          setProducts(data);
          setCollections(collections);

          localStorage.setItem("Products", JSON.stringify(data));
          localStorage.setItem("collections", JSON.stringify(collections));
          localStorage.setItem("userUsedCodes", JSON.stringify(UserUsedCodesArray));

          console.log(data);
          console.log(collections);

        })
        .catch(err => console.error(err));

    } else {

      axios.get(`${process.env.REACT_APP_URL}/api/getProductNoLogin`)
        .then(res => {

          const { data, collections } = res.data;

          setProducts(data);
          setCollections(collections);

          localStorage.setItem("Products", JSON.stringify(data));
          localStorage.setItem("collections", JSON.stringify(collections));

          console.log(data);
          console.log(collections);

        })
        .catch(err => console.error(err));

    }

  }, []);

  // const products = JSON.parse(localStorage.getItem("Products"))
  //Sample Data && Schema for Discount Codes
  // const codes = [{ _codeInput_: "NewCustomer100", _codeDiscount_: 100, _codeType_: 'fixed', used: false }, { code: "SummerSale10", discount: 10, method: 'percentage', used: false }];
  // localStorage.setItem('discountCodes', JSON.stringify(codes));
  //Sample Data && Schema for Collections 
  // const collections = [{ title: "New Arrival", image: "https://res.cloudinary.com/dypwavtvm/image/upload/v1771506113/ladin_lc1aag.jpg", description: "Discover our latest arrivals, featuring the freshest styles and trends to keep your wardrobe up-to-date." }, { title: "Best Seller", image: "https://res.cloudinary.com/dypwavtvm/image/upload/v1771506113/ladin_lc1aag.jpg", description: "Explore our best sellers, the most popular and highly rated products that customers love." }, { title: "Echlon One Collection", image: "https://res.cloudinary.com/dypwavtvm/image/upload/v1771506113/ladin_lc1aag.jpg", description: "Introducing the Echlon One Collection - a curated selection of premium products designed for those who demand excellence in style and quality." }];
  // localStorage.setItem('collections', JSON.stringify(collections));
  //Sample Data && Schema for Products
  // const products = [
  //   {
  //     id: "GloryDecay",
  //     title: "Glory Decay",
  //     price: 1500,
  //     mainimg: GloryBeigeimg,
  //     carousel: [GloryBeigeimg, GloryBlackimg, GloryWhiteimg],
  //     availableQuantity: 15,
  //     color: [
  //       { said: "Beige", hex: "#c2b280" },
  //       { said: "Black", hex: "#000000" },
  //       { said: "White", hex: "#ffffff" }
  //     ],
  //     sizes: ["M", "L", "XL"],
  //     description:
  //       "Experience the perfect blend of style and comfort with our Glory-Decay apparel. Crafted from high-quality materials, this piece is designed to keep you looking sharp and feeling great all day long.",
  //     reviews: [
  //       {
  //         id: 1,
  //         name: "Ahmed Khan",
  //         rating: 5,
  //         date: "2024-03-15",
  //         review: "Absolutely love this shirt! The quality is outstanding and the fit is perfect. The Egyptian hieroglyphs design is unique and eye-catching. Highly recommend!",
  //         product: "Glory Decay"
  //       },
  //       {
  //         id: 2,
  //         name: "Sara Ahmed",
  //         rating: 4,
  //         date: "2024-03-12",
  //         review: "Great quality fabric and comfortable to wear. The design is beautiful. Only wish it came in more colors. Overall very satisfied with the purchase.",
  //         product: "Glory Decay"
  //       },
  //       {
  //         id: 3,
  //         name: "Muhammad Ali",
  //         rating: 5,
  //         date: "2024-03-10",
  //         review: "Inifits has become my go-to brand for streetwear. This piece is exactly what I was looking for. Fast shipping and excellent customer service.",
  //         product: "Glory Decay"
  //       }
  //     ],
  //     collections_Primary: ["Echlon One Collection","New Arrival", "Best Seller"]

  //   },

  //   {
  //     id: "AlterOne",
  //     title: "Alter:ONE",
  //     price: 1200,
  //     mainimg: GloryBeigeimg,
  //     carousel: [GloryBeigeimg, GloryBlackimg, GloryWhiteimg],
  //     availableQuantity: 15,
  //     color: [
  //       { said: "Beige", hex: "#c2b280" },
  //       { said: "Black", hex: "#000000" },
  //       { said: "White", hex: "#ffffff" }
  //     ],
  //     sizes: ["M", "L", "XL"],
  //     description:
  //       "Experience the perfect blend of style and comfort with our Glory-Decay apparel. Crafted from high-quality materials, this piece is designed to keep you looking sharp and feeling great all day long.",
  //     reviews: [
  //       {
  //         id: 4,
  //         name: "Fatima Noor",
  //         rating: 4,
  //         date: "2024-03-08",
  //         review: "Love the minimalist design and the comfort level. Perfect for everyday wear. The price is reasonable for the quality you get.",
  //         product: "Alter:ONE"
  //       },
  //       {
  //         id: 5,
  //         name: "Hassan Raza",
  //         rating: 5,
  //         date: "2024-03-05",
  //         review: "Amazing brand! The attention to detail in their designs is impressive. This shirt has quickly become a favorite in my wardrobe.",
  //         product: "Alter:ONE"
  //       },
  //       {
  //         id: 6,
  //         name: "Ayesha Malik",
  //         rating: 4,
  //         date: "2024-03-03",
  //         review: "Good quality and unique design. The sizing runs a bit large, but overall very happy with my purchase. Will definitely buy again.",
  //         product: "Alter:ONE"
  //       },
  //       {
  //         id: 7,
  //         name: "Omar Farooq",
  //         rating: 5,
  //         date: "2024-02-28",
  //         review: "Inifits delivers on their promise of quality and affordability. The Egyptian hieroglyphs are printed perfectly and the fabric is premium.",
  //         product: "Alter:ONE"
  //       }
  //     ],
  //     collections_Primary: ["Echlon One Collection","New Arrival"]
  //   }
  // ];






  return (
    <>
      <div className="App">
        <UserProvider>

          <NavigationBar />
          <Routes>

            <Route path="/" element={<div className="rela">
              <HeroSection />
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>~Featured Products~</h1>
              <div className="pro" id='productBox'>
                {products.map((product, index) => (
                  <Card
                    key={product.idn}
                    id={product.idn}
                    title={product.title}
                    image={product.image}
                    price={product.price}
                    colors={product.colors}
                    carousel={product.carousel}
                    description={product.description}
                    initialColor={product.colors?.[0]?.hex || "#000000"}
                    size={product.sizes}
                    carouselLength={product.carousel?.length || 0}
                    reviews={product.reviews}
                    idr={product.idr}
                  />

                ))}
              </div>

            </div>} />
            <Route path='/Collections' element={<div className="rela">
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>Collections</h1>
              <div className="pro" id='productBox'>
                {collections.map((collection, index) => (
                  <CollectionCard
                    key={index}
                    title={collection.title}
                    image={collection.image}

                  />

                ))}
              </div>

            </div>} />

            <Route path='/Products' element={<div className="rela">
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>Products</h1>
              <div className="pro" id='productBox'>
                {products.map((product, index) => (
                  <Card
                    key={index}
                    id={product.idn}
                    title={product.title}
                    image={product.image}
                    price={product.price}
                    colors={product.colors}
                    description={product.description}
                    carousel={product.carousel}
                    initialColor={product.colors?.[0]?.hex || "#000000"}
                    size={product.sizes}
                    carouselLength={product.carousel?.length || 0}
                    reviews={product.reviews}
                    idr={product.idr}
                  />

                ))}
              </div>

            </div>} />
            <Route path='/About-Us' element={<div className="rela">
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>About Us</h1>
              <div className="Aboutustxt">
                <h2>Inifits:</h2>
                <div className="imgtxt">
                  <p>Inifits (est. 2025) is a newly launched clothing brand that considers quality, comfort, and affordability equally important, so that everyone in Pakistan can wear high-quality tees at really reasonable prices. Our most in-demand item is "Glory Decay," a tee with Egyptian hieroglyphs printed on it.</p>
                  <div className="imgofglo">
                    <img src={GloryBeigeimg} alt="Inifits Glory Decay" />
                  </div>
                </div>
              </div>

            </div>} />
            <Route path='/Contact-Us' element={<div className="rela">
              <ContactForm />
            </div>} />
            <Route path='/cart' element={<div className="rela">
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>Cart</h1>
              <Cart />
            </div>} />
            <Route path='/checkout' element={<div className="rela">
              <h1 id='label' style={{ display: 'block', borderBottom: '1px solid #c2b280', paddingBottom: '12px', width: '100%' }}>Checkout</h1>
              <Checkout />
            </div>} />
            <Route path='/Log-In' element={<div className="rela">
              <Login />
            </div>} />
            <Route path='/Sign-Up' element={<div className="rela">
              <Signup />
            </div>} />
            <Route path='/collection-page' element={<div className="rela">
              <CollectionPage />
            </div>} />
            <Route path='/Admin-Panel' element={
              <AdminProtection>
                <div className="rela">
                  <AdminPanel />
                </div>
              </AdminProtection>
            } />
            <Route path='/Inform-User' element={

              <div className="rela">
                <PlacedOrder />
              </div>

            } />
            <Route path='/Verify-Email-OTP' element={

              <div className="rela">
                <VerifyEmailOTP />
              </div>

            } />
            <Route path='/Reviews' element={<div className="rela">
              <Reviews />
            </div>} />
            <Route path='/Forgot-Password' element={<div className="rela">
              <ForgotPasswordEmail />
            </div>} />
            <Route path='/Reset-Password-OTP' element={<div className="rela">
              <ResetPasswordOTP />
            </div>} />
            <Route path='/track' element={<div className="rela">
              <TrackOrder />
            </div>} />
          </Routes>
          <Footer />
        </UserProvider>

      </div>
      <Analytics />
    </>
  );
}

export default App;
